/*
  Czat Smartsupp dla IWC HOME (iwchome.com i iwchome.de).

  Przeniesione z motywu Cossy (assets/third-party-scripts.js) - to samo konto
  i ten sam klucz. Z tamtego pliku wzięta jest tylko część czatu: chowanie
  dymka przy otwartych szufladach i przy przewijaniu oraz ładowanie po zgodzie
  Pandectes. Contentsquare zostaje w Cossy.

  Skrypt czatu dociąga się dopiero po pierwszej interakcji albo po 2 s,
  żeby nie obciążać pierwszego renderu.
*/
(() => {
  window._smartsupp = window._smartsupp || {};
  window._smartsupp.key = '043dfa8c63561365ab11f12285179acb9270a217';
  if (!window.smartsupp) {
    const o = (window.smartsupp = function () {
      o._.push(arguments);
    });
    o._ = [];
  }

  const locale = (document.documentElement.lang || 'pl').slice(0, 2);
  window.smartsupp('language', locale === 'de' ? 'de' : 'pl');

  const SMARTSUPP_BLOCKING_OVERLAY_SELECTOR =
    '.drawer, .product-popup, product-modal-gallery, product-sticky-cart, dialog, [role="dialog"][aria-modal="true"]';
  const SMARTSUPP_SCROLL_REVEAL_DELAY = 500;
  const observedSmartsuppOverlays = new WeakSet();
  let smartsuppHidden = false;
  let smartsuppHiddenForScroll = false;
  let smartsuppScrollEndTimer;
  let smartsuppVisibilityFrame;

  const isSmartsuppBlockingOverlayOpen = (overlay) => {
    if (overlay.matches('.drawer')) {
      return overlay.classList.contains('drawer--opened') || overlay.style.display === 'flex';
    }

    if (overlay.matches('.product-popup')) {
      return overlay.classList.contains('product-popup--open') || overlay.style.display === 'flex';
    }

    if (overlay.matches('product-modal-gallery')) {
      return overlay.style.display === 'block';
    }

    if (overlay.matches('dialog')) {
      return overlay.hasAttribute('open');
    }

    if (overlay.hidden || overlay.getAttribute('aria-hidden') === 'true') return false;

    const styles = window.getComputedStyle(overlay);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && overlay.getClientRects().length > 0;
  };

  const syncSmartsuppVisibility = () => {
    const hasOpenOverlay = Array.from(document.querySelectorAll(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)).some(
      isSmartsuppBlockingOverlayOpen
    );
    const shouldHide = smartsuppHiddenForScroll || hasOpenOverlay;
    const widgetContainer = document.querySelector('#smartsupp-widget-container');

    if (widgetContainer) {
      if (shouldHide) {
        widgetContainer.style.setProperty('display', 'none', 'important');
      } else {
        widgetContainer.style.removeProperty('display');
      }
    }

    if (shouldHide === smartsuppHidden) return;

    smartsuppHidden = shouldHide;
    window.smartsupp(shouldHide ? 'chat:hide' : 'chat:show');
  };

  const handleSmartsuppScroll = () => {
    if (!smartsuppHiddenForScroll) {
      smartsuppHiddenForScroll = true;
      syncSmartsuppVisibility();
    }

    window.clearTimeout(smartsuppScrollEndTimer);
    smartsuppScrollEndTimer = window.setTimeout(() => {
      smartsuppHiddenForScroll = false;
      syncSmartsuppVisibility();
    }, SMARTSUPP_SCROLL_REVEAL_DELAY);
  };

  const requestSmartsuppVisibilitySync = () => {
    if (smartsuppVisibilityFrame) return;

    smartsuppVisibilityFrame = window.requestAnimationFrame(() => {
      smartsuppVisibilityFrame = undefined;
      syncSmartsuppVisibility();
    });
  };

  const observeSmartsuppOverlay = (overlay, observer) => {
    if (observedSmartsuppOverlays.has(overlay)) return;

    observedSmartsuppOverlays.add(overlay);
    observer.observe(overlay, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal', 'role'],
    });
  };

  const initializeSmartsuppOverlayVisibility = () => {
    const overlayObserver = new MutationObserver(requestSmartsuppVisibilitySync);
    const observeOverlaysWithin = (root) => {
      if (root.matches && root.matches(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)) {
        observeSmartsuppOverlay(root, overlayObserver);

        if (root.matches('[role="dialog"][aria-modal="true"]') && root.parentElement) {
          observeSmartsuppOverlay(root.parentElement, overlayObserver);
        }
      }

      if (root.querySelectorAll) {
        root
          .querySelectorAll(SMARTSUPP_BLOCKING_OVERLAY_SELECTOR)
          .forEach((overlay) => {
            observeSmartsuppOverlay(overlay, overlayObserver);

            if (overlay.matches('[role="dialog"][aria-modal="true"]') && overlay.parentElement) {
              observeSmartsuppOverlay(overlay.parentElement, overlayObserver);
            }
          });
      }
    };

    observeOverlaysWithin(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => observeOverlaysWithin(node));
      });
      requestSmartsuppVisibilitySync();
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', handleSmartsuppScroll, { passive: true });
    syncSmartsuppVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSmartsuppOverlayVisibility, { once: true });
  } else {
    initializeSmartsuppOverlayVisibility();
  }

  const SMARTSUPP_CONSENT_CATEGORY = 'C0001';
  const CONSENT_MAX_ATTEMPTS = 40;
  const CONSENT_RETRY_DELAY = 250;
  let smartsuppLoadRequested = false;

  const hasExplicitShopifyConsent = () => {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy || !customerPrivacy.currentVisitorConsent) return false;
    const visitorConsent = customerPrivacy.currentVisitorConsent();
    return visitorConsent && (visitorConsent.preferences === 'yes' || visitorConsent.preferences === true);
  };

  const shopifyConsentEventAllows = (event) => {
    const detail = event && event.detail;
    return Boolean(
      detail && (detail.preferencesAllowed === true || detail.preferencesProcessingAllowed === true || detail.preferences === true)
    );
  };

  // C0001 to w Pandectes kategoria niezbędna - czat ładuje się po każdej świadomej decyzji
  // w banerze (także „Odrzuć” dla pozostałych kategorii), ale nie zanim baner zniknie.
  const pandectesDecisionMade = () => {
    const cookie = document.cookie.split('; ').find((item) => item.indexOf('_pandectes_gdpr=') === 0);
    if (!cookie) return false;
    try {
      const consent = JSON.parse(window.atob(decodeURIComponent(cookie.substring('_pandectes_gdpr='.length))));
      return Boolean(consent && consent.method === 'explicit');
    } catch (error) {
      return false;
    }
  };

  const loadSmartsupp = () => {
    if (window._smartsuppLoaded) return;
    window._smartsuppLoaded = true;

    const c = document.createElement('script');
    c.type = 'text/javascript';
    c.charset = 'utf-8';
    c.async = true;
    c.src = 'https://www.smartsuppchat.com/loader.js?';
    document.head.appendChild(c);
  };

  const maybeLoadSmartsupp = (event) => {
    if (!smartsuppLoadRequested) return;
    if (hasExplicitShopifyConsent() || shopifyConsentEventAllows(event) || pandectesDecisionMade()) {
      loadSmartsupp();
    }
  };

  document.addEventListener('visitorConsentCollected', maybeLoadSmartsupp);

  const requestSmartsuppLoad = () => {
    if (smartsuppLoadRequested) return;
    smartsuppLoadRequested = true;
    let attempts = 0;
    const poll = () => {
      maybeLoadSmartsupp();
      if (window._smartsuppLoaded) return;
      attempts += 1;
      // Pierwsze 10 s co 250 ms, potem co sekundę aż do decyzji w banerze -
      // klient może kliknąć zgodę dużo później niż przy pierwszej interakcji.
      window.setTimeout(poll, attempts < CONSENT_MAX_ATTEMPTS ? CONSENT_RETRY_DELAY : 1000);
    };
    poll();
  };

  const timer = setTimeout(requestSmartsuppLoad, 2000);
  ['mouseover', 'keydown', 'touchstart', 'scroll'].forEach((eventName) => {
    window.addEventListener(
      eventName,
      () => {
        clearTimeout(timer);
        requestSmartsuppLoad();
      },
      { once: true, passive: true }
    );
  });
})();
